import { FC, useMemo } from 'react';

import type {
  CardProps,
  CombinedFeatureTypes,
} from '@/features/selectionsPanel/constants';
import { featureTypeContent } from '@/features/selectionsPanelOld/constants';
import { AcresFeature } from '@/models/features';

type Props = {
  selections: AcresFeature[];
  selectionType: CombinedFeatureTypes;
};

export const SelectionContent: FC<Props> = ({ selections, selectionType }) => {
  const Content: FC<CardProps<AcresFeature>> = useMemo(() => {
    return featureTypeContent[selectionType];
  }, [selectionType]);

  return (
    <div className="flex flex-col gap-2">
      {selections.map((feature, idx) => {
        return <Content key={feature.id} feature={feature} idx={idx} />;
      })}
    </div>
  );
};
